import React from 'react';

import { Button, Modal, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function DeleteModal({ chart, organization, syncCharts, onClose }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [isDeleting, setIsDeleting] = React.useState(false);

    const onSubmit = React.useCallback(() => {
        setIsDeleting(true);
        chart
            .delete({
                organizationId: organization.id,
                chartId: chart.id
            })
            .then(() => {
                toast.success(t('ticket.charts.chartlist.deleteModal.toast-success'));
                onClose();
                syncCharts({ allow_cache: false, cache: false });
                setIsDeleting(false);
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.charts.chartlist.deleteModal.toast-error'));
            })
            .finally(() => {
                setIsDeleting(false);
            });
    }, [chart, organization, toast, onClose, syncCharts]);

    return (
        <Modal
            allowExternalClosing={false}
            open={Boolean(chart)}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.common.action.delete')} onClick={onSubmit} isLoading={isDeleting} />}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} disabled={isDeleting} />}
            title={t('ticket.charts.chartlist.deleteModal.title')}
        >
            <div>{t('ticket.charts.chartlist.deleteModal.description')}</div>
        </Modal>
    );
}
